export default {
  color: {
    background: "#222222",
    textColor: "#09a903",
    textShadow: "3px 2px 0px #CEF4CD",
  },
  gameArea: {
    background: "rgba(206, 244, 205, 0.25)",
    boxShadow: "0px 4px 4px rgba(206, 244, 205, 0.25)",
  },
  button: {
    textColor: "#CEF4CD",
    boxShadow:
      " 0px 4px 4px rgba(206, 244, 205, 0.25), inset 3px 4px 4px rgba(206, 244, 205, 0.5)",
    boxShadowActive: " inset 3px 4px 4px rgba(0, 0, 0, 0.5)",
  },
};
